module.exports = __webpack_public_path__ + "static/media/VendingDefaultIcon.7ea01d41.png";